module.exports = __webpack_public_path__ + "img/1-4.1c78364e.svg";